import React, { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "hooks/reduxHooks";
import { selectCurrentPatient } from "store/PatientStore/selectors";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { setCurrentClinician } from "store/ClinicianStore/clinicianSlice";
import { AuthRepository } from "repositories/AuthRepository";

import Skeleton from "react-loading-skeleton";
import { AthleteInfo } from "../../components/Athlete/AthleteInfo";
import { selectRequests } from "../../../../store/LoadingStore/selectors";
import { Requests } from "../../../../types/requests";

export const AthleteInfoContainer = () => {
  const dispatch = useAppDispatch();

  const patient = useAppSelector(selectCurrentPatient);
  const currentClinician = useAppSelector(selectCurrentClinician);
  const loading = useAppSelector((state) =>
    selectRequests([Requests.getPatient], state)
  );

  useEffect(() => {
    const getClinician = async () => {
      const authRepository = AuthRepository.getInstance();

      const currentClinician = await authRepository.getMe();
      dispatch(setCurrentClinician(currentClinician));
    };

    getClinician();
  }, []);

  return (
    <div>
      {loading ? (
        <Skeleton height={180} />
      ) : (
        <AthleteInfo
          currentClinician={currentClinician}
          firstName={patient?.profileInfo?.firstName}
          lastName={patient?.profileInfo?.lastName}
          uniqueId={patient?.profileInfo?.mrn || patient?._id}
          patientImage={patient?.imageUrl}
          dateOfBirth={patient?.profileInfo?.dateOfBirth}
          email={patient?.profileInfo?.email}
          gender={patient?.profileInfo?.gender}
          phone={patient?.profileInfo?.phoneNumber}
          sportPosition={patient?.profileInfo?.sportPosition ?? []}
          sports={patient?.profileInfo?.sports ?? []}
          teams={patient?.profileInfo?.teams ?? []}
          status={patient?.profileInfo?.authStatus ?? "-"}
          inviteDates={patient?.profileInfo?.inviteDates ?? ["-"]}
        />
      )}
    </div>
  );
};
